module.exports = __webpack_public_path__ + "static/media/snowg.8f482472.png";